import { start } from "./app/start";
import "./styles/base.css";

start(window, document);
